import { useState, useEffect, useRef, useCallback } from 'react';

export default function useBroadcastChannel<T>(channelName: string) {
  const [message, setMessage] = useState<T | null>(null);
  const channelRef = useRef<BroadcastChannel | null>(null);

  useEffect(() => {
    channelRef.current = new BroadcastChannel(channelName);

    const handleMessage = (event: MessageEvent) => {
      setMessage(event.data);
    };

    channelRef.current.addEventListener('message', handleMessage);

    return () => {
      if (channelRef.current) {
        channelRef.current.removeEventListener('message', handleMessage);
        channelRef.current.close();
        channelRef.current = null;
      }
    };
  }, [channelName]);

  const sendMessage = useCallback((data: T) => {
    if (channelRef.current) {
      channelRef.current.postMessage(data);
    }
  }, []);

  return { message, sendMessage, channel: channelRef.current };
}
